/* eslint-disable @typescript-eslint/no-shadow */
import L, { LatLng, LatLngBounds, LatLngLiteral, Point } from 'leaflet';
import 'src/libs/leaflet-corridor';

import { max } from 'lodash';

import { bearing } from 'src/app/helpers/turf';
import { mapSettings } from 'src/app/utils';
import { MapDrawingsStatus } from 'src/types/mixed.type';
import { yolService } from 'src/app/services';
import { RulerPopupArgs } from 'src/app/components/MapComponent/map.config';
import { getProperDistanceText } from 'src/app/utils/mapUtil';
import styles from 'src/controllers/controller-styles.module.scss';
import { MapViewState } from 'src/enums/map.enum';
import { t } from 'i18next';
import { MapController } from './MapController';
import { MapMarkerController } from './MapMarkerController';

const AVERAGE_LANE_WIDTH_IN_METERS = 3.4;

export class MapVisualController extends MapController {
  mapMarkerController: MapMarkerController | undefined;

  rectangles: L.Rectangle[];

  polylines: L.Polyline[];

  rulerPolylines: L.Polyline[] = [];

  rulerDistanceArrays: number[][] = [];

  rulerArray: LatLng[] = [];

  rulerMarkers: L.CircleMarker[] = [];

  rulerMovingMarker: L.CircleMarker | undefined = undefined;

  rulerTooltip = L.tooltip();

  initialPlaces: { latlng: LatLng; layerPoint: Point }[] = [];

  commandPolygon: L.Polygon | undefined;

  drawInputLayers = L.featureGroup();

  maritimeDrawings = L.featureGroup();

  airDrawings = L.featureGroup();

  roadDrawings = L.featureGroup();

  actions: {
    // openQuadDetails?: (quad: Quad) => void;
  };

  rulerActiveStatus = false;

  zoomActiveStatus = false;

  selectUnitsActiveStatus = false;

  onAreaSelectedForSelectUnits: ((bounds: LatLngBounds) => void) | undefined = undefined;

  rulerPopup: (options: RulerPopupArgs) => void | undefined;

  constructor(
    map: L.Map,
    isTheatre: boolean,
    mapViewState: MapViewState,
    // quadTreeController: QuadTreeController,
    rulerPopup: (options: RulerPopupArgs) => void,
  ) {
    super(map, mapViewState);

    this.map.addLayer(this.drawInputLayers);

    this.rulerPopup = rulerPopup;

    this.actions = {};

    this.rectangles = [];
    this.polylines = [];

    // this.setMaritimeDrawings();
    // this.setAirDrawings();
    this.setRoadDrawings();
  }

  setMapMarkerController = (controller: MapMarkerController) => {
    this.mapMarkerController = controller;
  };

  setOnAreaSelectedForSelectUnits = (cb: (bounds: LatLngBounds) => void) => {
    this.onAreaSelectedForSelectUnits = cb;
  };

  // setOpenQuadDetailsActions = (cb: (quad: Quad) => void) => {
  //   this.actions.openQuadDetails = cb;
  // };

  // setMaritimeDrawings = async () => {
  //   const {
  //     data: { rows: maritimeData },
  //   } = await trafikBolumlemeYollariService.trafikBolumlemeYollariMapLookup({ blockSpinner: true });

  //   maritimeData.forEach((data) => {
  //     const { baslangicDugumNoktasiEntity, bitisDugumNoktasiEntity, genisligi } = data;

  //     if (baslangicDugumNoktasiEntity.koordinatlari && bitisDugumNoktasiEntity.koordinatlari) {
  //       const startPoint = L.latLng(
  //         baslangicDugumNoktasiEntity.koordinatlari.lat,
  //         baslangicDugumNoktasiEntity.koordinatlari.lng,
  //       );

  //       const endPoint = L.latLng(bitisDugumNoktasiEntity.koordinatlari.lat, bitisDugumNoktasiEntity.koordinatlari.lng);

  //       this.maritimeDrawings.addLayer(
  //         L.corridor([startPoint, endPoint], {
  //           corridor: max([genisligi, 1000]),
  //         }),
  //       );
  //     }
  //   });
  // };

  // setAirDrawings = async () => {
  //   const {
  //     data: { rows: airData },
  //   } = await havaKoridorlariService.havaKoridorlariMapLookup({ blockSpinner: true });

  //   airData.forEach((data) => {
  //     const { baslangicDugumNoktasi, bitisDugumNoktasi, koridorGenisligi } = data;

  //     if (baslangicDugumNoktasi.koordinatlari && bitisDugumNoktasi.koordinatlari) {
  //       const startPoint = L.latLng(baslangicDugumNoktasi.koordinatlari.lat, baslangicDugumNoktasi.koordinatlari.lng);

  //       const endPoint = L.latLng(bitisDugumNoktasi.koordinatlari.lat, bitisDugumNoktasi.koordinatlari.lng);

  //       this.airDrawings.addLayer(
  //         L.corridor([startPoint, endPoint], {
  //           corridor: max([koridorGenisligi * FEET_TO_METER, 1000]),
  //         }),
  //       );
  //     }
  //   });
  // };

  setRoadDrawings = async () => {
    const {
      data: { rows: roadData },
    } = await yolService.yolMapLookup({ blockSpinner: true });

    roadData.forEach((data: { baslangicDugumNoktasi: any; bitisDugumNoktasi: any; seritSayisi: any }) => {
      const { baslangicDugumNoktasi, bitisDugumNoktasi, seritSayisi } = data;

      if (baslangicDugumNoktasi.konum && bitisDugumNoktasi.konum) {
        const startPoint = L.latLng(baslangicDugumNoktasi.konum.lat, baslangicDugumNoktasi.konum.lng);

        const endPoint = L.latLng(bitisDugumNoktasi.konum.lat, bitisDugumNoktasi.konum.lng);

        this.roadDrawings.addLayer(
          L.corridor([startPoint, endPoint], {
            corridor: max([seritSayisi * AVERAGE_LANE_WIDTH_IN_METERS, 100]),
          }),
        );
      }
    });
  };

  toggleMapDrawings = (drawingStatus: MapDrawingsStatus) => {
    if (drawingStatus.maritime) {
      if (!this.map.hasLayer(this.maritimeDrawings)) {
        this.map.addLayer(this.maritimeDrawings);
      }
    } else {
      this.map.removeLayer(this.maritimeDrawings);
    }

    if (drawingStatus.air) {
      if (!this.map.hasLayer(this.airDrawings)) {
        this.map.addLayer(this.airDrawings);
      }
    } else {
      this.map.removeLayer(this.airDrawings);
    }

    if (drawingStatus.road) {
      if (!this.map.hasLayer(this.roadDrawings)) {
        this.map.addLayer(this.roadDrawings);
      }
    } else {
      this.map.removeLayer(this.roadDrawings);
    }
  };

  clearMap = () => {
    this.polylines.forEach((polyline) => this.map.removeLayer(polyline));
    this.polylines = [];
    this.initEvents();
  };

  initEvents = () => {};

  // onClickSetDefault = (isTheatre: boolean) => {
  //   this.map.off('click');
  //   if (isTheatre) {
  //     this.map?.on('click', (e: L.LeafletMouseEvent) => {
  //       this.onMouseClick(e);
  //     });
  //   }
  // };

  // onRightClickSetDefault = (isTheatre: boolean) => {
  //   this.map.off('contextmenu');
  //   if (isTheatre) {
  //     this.map?.on('contextmenu', (e: L.LeafletMouseEvent) => {
  //       this.onRightClick(e);
  //     });
  //   }
  // };

  zoomIn = () => {
    this.map?.zoomIn();
  };

  zoomOut = () => {
    this.map?.zoomOut();
  };

  rulerOnEscClick = (e: any) => {
    if (e.keyCode === 27) {
      // remove currently selecting node. not initials
      if (this.rulerArray.length > 0) {
        this.rulerArray.pop();
        this.rulerPolylines[this.rulerPolylines.length - 1].setLatLngs(this.rulerArray);
        this.rulerPolylines[this.rulerPolylines.length - 1].addTo(this.map);
        this.onEndRoute();
      }

      // remove moving marker
      if (this.rulerMovingMarker) {
        this.rulerMovingMarker.removeFrom(this.map);
        this.rulerMovingMarker.unbindTooltip();
        this.rulerMovingMarker = undefined;
      }
    }
  };

  disableRuler = () => {
    this.mapMarkerController?.enableMarkersLeftClick();
    this.map.doubleClickZoom.enable();
    this.map.off('mouseout', this.onMouseOutRuler);
    this.map.off('mouseover', this.onMouseOverRuler);
    this.map.off('click', this.onMouseDownRuler);
    this.map.off('mousemove', this.rulerMouseMoveEventHandler);
    this.map.off('dblclick', this.onEndRoute);
    L.DomEvent.off(this.map.getContainer(), 'keydown', this.rulerOnEscClick, this);
    // remove polylines
    this.rulerPolylines.forEach((o) => {
      o.removeFrom(this.map);
    });
    this.rulerPolylines = [];
    this.rulerArray = [];
    this.initialPlaces = [];

    // remove marker and tooltips
    this.rulerMarkers.forEach((o) => {
      o.removeFrom(this.map);
      o.unbindTooltip();
    });

    // remove moving marker
    if (this.rulerMovingMarker) {
      this.rulerMovingMarker.removeFrom(this.map);
      this.rulerMovingMarker.unbindTooltip();
      this.rulerMovingMarker = undefined;
    }
  };

  onMouseOutRuler = (e: L.LeafletMouseEvent) => {
    const northEast = this.map.getBounds().getNorthEast();
    const southWest = this.map.getBounds().getSouthWest();

    const minLat = southWest.lat;
    const minLng = southWest.lng;
    const maxLat = northEast.lat;
    const maxLng = northEast.lng;

    // only turn off if mouse is not in limits
    if (e.latlng.lng < minLng || e.latlng.lng > maxLng || e.latlng.lat < minLat || e.latlng.lat > maxLat) {
      this.map.off('click', this.onMouseDownRuler);
    }
  };

  onMouseOverRuler = () => {
    this.map.on('click', this.onMouseDownRuler);
  };

  onRulerToggle = (status: boolean) => {
    // enable and disable agent clicking
    // enable and disable doubleclick zoom because dblclick has ending map route functionality
    if (status) {
      this.mapMarkerController?.disableMarkersLeftClick();
      this.map.doubleClickZoom.disable();
      this.map.on('mouseout', this.onMouseOutRuler);
      this.map.on('mouseover', this.onMouseOverRuler);
      this.map.on('dblclick', this.onEndRoute);
      L.DomEvent.on(this.map.getContainer(), 'keydown', this.rulerOnEscClick, this);
    } else {
      this.disableRuler();
    }

    this.rulerActiveStatus = status;
  };

  onZoomToggle = (status: boolean) => {
    if (status) {
      this.map.dragging.disable();
      this.map.on('mousedown', this.rectangularZoomOnMouseDown);
    } else {
      this.map.dragging.enable();
      this.map.off('mousedown', this.rectangularZoomOnMouseDown);
    }

    this.zoomActiveStatus = status;
  };

  onSelectUnitsToggle = (status: boolean) => {
    if (status) {
      this.map.dragging.disable();
      this.map.on('mousedown', this.selectAreaOnMouseDownForUnits);
    } else {
      this.map.dragging.enable();
      this.map.off('mousedown', this.selectAreaOnMouseDownForUnits);
    }

    this.selectUnitsActiveStatus = status;
  };

  bindOnClick = (cb: (e: L.LeafletMouseEvent) => void) => {
    if (this.map !== undefined) {
      this.map.off('click');
      this.map.on('click', cb);
    }
  };

  // unbindOnClick = (isTheatre: boolean) => {
  //   if (this.map !== undefined) {
  //     this.map.off('click');

  //     this.onClickSetDefault(isTheatre);
  //   }
  // };

  // onRightClick = (e: L.LeafletMouseEvent) => {
  //   // this.removeRectangles(); // Removes any layer if there is a previously selected quad.

  //   if (!this.quadTreeController.isReady())
  //     return displayErrorMessage('You cannot use this action before setting quad tree');

  //   const quad = this.quadTreeController.getQuadByLatLng(e.latlng); // Finds the selected quad
  //   if (!quad) return; // Returns if it cannot cannot find any quad.

  //   this.quadTreeController.divideQuadById(quad.quadId);
  //   this.quadTreeController.highlightQuadPolygons();
  //   this.removeRectangles();
  // };

  // onMouseClick = (e: L.LeafletMouseEvent) => {
  //   if (this.rulerActiveStatus || this.zoomActiveStatus) return;

  //   // this.removeRectangles(); // Removes any layer if there is a previously selected quad.

  //   if (!this.quadTreeController.isReady())
  //     return displayErrorMessage('You cannot use this action before setting quad tree');

  //   const quad = this.quadTreeController.getQuadByLatLng(e.latlng); // Finds the selected quad
  //   if (!quad) return; // Returns if it cannot cannot find any quad.

  //   if (this.actions.openQuadDetails) this.actions.openQuadDetails(quad);
  // };

  onMouseClickGetLocation = (e: L.LeafletMouseEvent): LatLngLiteral => {
    return e.latlng;
  };

  // drawQuadsRectangles = (quadIds: string[]) => {
  //   this.removeRectangles();
  //   quadIds.forEach((item) => {
  //     if (this.quadTreeController && this.quadTreeController.mainQuad) {
  //       const quad = this.quadTreeController.mainQuad.getChildWithId(item);

  //       if (quad) {
  //         const topRight = L.latLng(quad.topRight[0], quad.topRight[1]);
  //         const botLeft = L.latLng(quad.botLeft[0], quad.botLeft[1]);
  //         const corners = L.latLngBounds(botLeft, topRight);

  //         const rectangle = L.rectangle(corners, {
  //           weight: 1,
  //           opacity: 0.5,
  //           smoothFactor: 1,
  //         });

  //         rectangle.addTo(this.map);

  //         this.rectangles.push(rectangle);
  //       }
  //     }
  //   });
  // };

  removeRectangles = () => {
    if (this.map !== undefined) {
      this.rectangles.forEach((rectangle) => {
        this.map?.removeLayer(rectangle);
        rectangle.unbindPopup();
        rectangle.closePopup();
      });

      this.rectangles = [];
    }
  };

  // setMapCenter = (e: L.LeafletMouseEvent) => {
  //   mapSettings.setSetting('center', [e.latlng.lat, e.latlng.lng]);
  // };

  centerMap = (point?: L.LatLngLiteral) => {
    if (point) {
      this.map.setView(point, this.map.getZoom());
    } else {
      this.map.setView(mapSettings.getSetting('center') as L.LatLngTuple, this.map.getZoom());
    }
  };

  selectAreaOnMouseDownForUnits = (e: L.LeafletMouseEvent) => {
    if (e.originalEvent.button !== 0) return;

    const initial = {
      latlng: e.latlng,
      layerPoint: e.layerPoint,
    };

    const rectangle = L.rectangle(this.map.getBounds().pad(-0.1), {
      color: '#808080',
      weight: 1,
    });

    const mouseMoveEventHandler = (e: L.LeafletMouseEvent) => {
      this.onMouseMove(e, rectangle, initial);
    };
    this.map.on('mousemove', mouseMoveEventHandler);

    this.map.on('mouseup', (e: L.LeafletMouseEvent) => {
      this.map.off('mouseup');
      const { current } = this.onMouseUp(e, rectangle, initial);

      if (this.onAreaSelectedForSelectUnits) {
        this.onAreaSelectedForSelectUnits(L.latLngBounds(initial.latlng, current.latlng));
      }

      this.map.off('mousemove', mouseMoveEventHandler);
    });
  };

  onMouseMove = (e: L.LeafletMouseEvent, rectangle: L.Rectangle, initial: { latlng: L.LatLngExpression }) => {
    if (rectangle) {
      rectangle.setBounds(L.latLngBounds(initial.latlng, e.latlng));
      rectangle.addTo(this.map);
    }
  };

  onMouseUp = (
    e: L.LeafletMouseEvent,
    rectangle: L.Rectangle,
    initial: { layerPoint: { x: number; y: number }; latlng: L.LatLngExpression },
  ) => {
    rectangle.removeFrom(this.map);

    const current = {
      latlng: e.latlng,
      layerPoint: e.layerPoint,
    };

    this.map.removeLayer(rectangle);
    this.map.off('mouseup');

    return {
      initial,
      current,
    };
  };

  rectangularZoomOnMouseDown = (e: L.LeafletMouseEvent) => {
    if (e.originalEvent.button !== 0) return;

    const initial = {
      latlng: e.latlng,
      layerPoint: e.layerPoint,
    };

    const rectangle = L.rectangle(this.map.getBounds().pad(-0.1), {
      color: '#808080',
      weight: 1,
    });

    const mouseMoveEventHandler = (e: L.LeafletMouseEvent) => {
      this.onMouseMove(e, rectangle, initial);
    };
    this.map.on('mousemove', mouseMoveEventHandler);

    this.map.on('mouseup', (e: L.LeafletMouseEvent) => {
      this.map.off('mouseup');
      const { current } = this.onMouseUp(e, rectangle, initial);

      const area = Math.abs(
        (initial.layerPoint.x - current.layerPoint.x) * (initial.layerPoint.y - current.layerPoint.y),
      );

      if (area >= 250) {
        this.map.fitBounds(L.latLngBounds(initial.latlng, current.latlng));
      }

      this.map.off('mousemove', mouseMoveEventHandler);
    });
  };

  getRulerToolTipText = (points: L.LatLng[], distance: number, totalDistance: number) => {
    const br = bearing(points[points.length - 2], points[points.length - 1]).toFixed(0);
    const textDistancePart = getProperDistanceText(distance);
    const textTotalDistancePart = getProperDistanceText(totalDistance);
    const totalDistancePart = totalDistance
      ? `<br><b>${t('hymotsc.ruler.totalDistance')}:</b>&nbsp;${textTotalDistancePart}`
      : '';
    const text = `<b>${t('hymotsc.ruler.bearing')}:</b>&nbsp;${br}&nbsp;&deg;<br><b>${t(
      'hymotsc.ruler.distance',
    )}:</b>&nbsp;${textDistancePart}${totalDistancePart}`;
    return text;
  };

  getRulerMeasurements = () => {
    const points = this.rulerPolylines[this.rulerPolylines.length - 1].getLatLngs() as L.LatLng[];
    const distance = Number(this.map.distance(points[points.length - 2], points[points.length - 1]).toFixed(0));
    const currNode = this.rulerDistanceArrays.length - 1;
    return { points, distance, currNode };
  };

  rulerMouseMoveEventHandler = (e: L.LeafletMouseEvent) => {
    // all drawing done here
    // on mouse move create a new polyline with initial places and current mouse place
    this.rulerArray = [...this.initialPlaces.map((o) => o.latlng)];
    this.rulerArray.push(e.latlng);
    this.rulerPolylines[this.rulerPolylines.length - 1].setLatLngs(this.rulerArray);
    this.rulerPolylines[this.rulerPolylines.length - 1].addTo(this.map);

    // moving marker on mouse move
    const { points, distance, currNode } = this.getRulerMeasurements();

    // eslint-disable-next-line prefer-const
    let movingDistances = [...this.rulerDistanceArrays[currNode], distance];
    const totalDistance = movingDistances.length > 1 ? movingDistances.reduce((acc, curr) => acc + curr, 0) : 0;

    const text = this.getRulerToolTipText(points, distance, totalDistance);

    const clickedLatLng = L.latLng(e.latlng.lat, e.latlng.lng);
    const newCircleMarker = L.circleMarker(L.latLng(0, 0), { color: 'rgba(0, 0, 0, .5)', radius: 3 });
    if (this.rulerMovingMarker) {
      this.rulerMovingMarker.removeFrom(this.map);
      this.rulerMovingMarker.unbindTooltip();
    }
    this.rulerMovingMarker = newCircleMarker;
    this.rulerMovingMarker
      .setLatLng(clickedLatLng)
      .bindTooltip(text, { permanent: true, className: styles.movingTooltip })
      .addTo(this.map)
      .openTooltip();
  };

  onEndRoute = () => {
    // end current route and create the next routes first initial as a placeholder, just to change later
    // see that we dont push it to initalplaces
    this.map.off('mousemove', this.rulerMouseMoveEventHandler);
    const initialPlace = this.initialPlaces[this.initialPlaces.length - 1];
    this.rulerArray = [];
    this.initialPlaces = [];
    const newPolyline = L.polyline([initialPlace.latlng, initialPlace.latlng], {
      color: 'rgba(0, 0, 0, .5)',
    });
    this.rulerPolylines.push(newPolyline);
    this.rulerDistanceArrays.push([]);
  };

  onMouseDownRuler = (e: L.LeafletMouseEvent) => {
    if (e.originalEvent.button !== 0) return;

    if (Number(this.initialPlaces.length) > 0) {
      const { points, distance, currNode } = this.getRulerMeasurements();

      this.rulerDistanceArrays[currNode].push(Number(distance));
      const currNodeLength = this.rulerDistanceArrays[currNode].length;

      // this is where we draw marker and tooltip
      if (
        currNodeLength < 2 ||
        this.rulerDistanceArrays[currNode][currNodeLength - 1] !==
          this.rulerDistanceArrays[currNode][currNodeLength - 2]
      ) {
        // total distance calculation
        const totalDistance =
          this.rulerDistanceArrays[currNode].length > 1
            ? this.rulerDistanceArrays[currNode].reduce((acc, curr) => acc + curr, 0)
            : 0;

        const text = this.getRulerToolTipText(points, distance, totalDistance);

        const clickedLatLng = L.latLng(points[points.length - 1].lat, points[points.length - 1].lng);
        const newCircleMarker = L.circleMarker(L.latLng(0, 0), { color: 'rgba(0, 0, 0, .5)', radius: 3 });
        this.rulerMarkers.push(newCircleMarker);

        this.rulerMarkers[this.rulerMarkers.length - 1]
          .setLatLng(clickedLatLng)
          .bindTooltip(text, { permanent: true })
          .addTo(this.map)
          .openTooltip();
      } else {
        // if last 2 distances are same that means dbl click happened pop the last one
        this.rulerDistanceArrays[currNode].pop();
      }
    }

    // initial places means selected and locked places
    const initial = {
      latlng: e.latlng,
      layerPoint: e.layerPoint,
    };
    this.initialPlaces.push(initial);

    // if its first click set the start point
    if (this.rulerPolylines.length < 1) {
      const newPolyline = L.polyline([initial.latlng, initial.latlng], { color: 'rgba(0, 0, 0, .5)' });
      this.rulerPolylines.push(newPolyline);
      this.rulerDistanceArrays.push([]);
    }

    this.map.on('mousemove', this.rulerMouseMoveEventHandler);
  };

  drawCommandPolygon = (coords: L.LatLngExpression[]) => {
    if (this.commandPolygon) {
      this.commandPolygon.remove();
    }

    this.commandPolygon = L.polygon(coords, { color: 'var(--ete-primary-green-color)', fillOpacity: 0.2 }).addTo(
      this.map,
    );
  };
}
